import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "./components/AppHeader";

const ExitPage = () => {
  useEffect(() => {
    const confetti = document.createElement("div");
    confetti.style.position = "fixed";
    confetti.style.top = "20px";
    confetti.style.right = "20px";
    confetti.style.fontSize = "2rem";
    confetti.style.zIndex = "1000";
    document.body.appendChild(confetti);
  }, []);

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-secondary font-sans">
      {/* Header */}
      <AppHeader titleSize="text-5xl" />

      {/* Banner */}
      <div className="bg-accent text-center py-4">
        <h2 className="text-2xl font-bold text-primary underline">Thank you for using DeepToast!</h2>
      </div>

      {/* Main Content */}
      <div className="flex items-center justify-center h-full py-20">
        <div className="bg-white p-10 rounded shadow-lg text-center space-y-6">
          <p className="text-gray-600 text-lg">
            We appreciate your time. Hope to see you again soon!
          </p>

          <div className="flex flex-col gap-4 w-full max-w-xs mx-auto">
            <button
              onClick={() => navigate("/deeptoast")}
              className="bg-indigo-600 text-white py-2 px-4 rounded hover:bg-indigo-700"
            >
              Generate More Questions
            </button>

            <button
              onClick={() => navigate("/")}
              className="bg-gray-700 text-white py-2 px-4 rounded hover:bg-gray-800"
            >
              Return to DeepToast Home Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitPage;
